<template>
    <div :class="model.size">
        <div>
            <label class="font-weight-bold" :for="'input' + _uid">{{ model.label }}</label>
            <i class="far fa-edit float-right text-primary pointer" @click="showEditPrompt"></i>
        </div>
        <div class="form-group row" aria-describedby="descriptionHelp">
            <div class="input-group">
                <div class="col-6 col-md-4">
                    <dropdown :load-by-parent-sort="true"
                              :parent-sort="nomenclature.PersonIdentificationType"
                              :fieldName="$t('person.egn')"
                              v-model="identification.identificationTypeId"></dropdown>
                </div>
                <div class="col-6 col-md-8 py-1">
                    <input type="text" class="form-control"
                           v-model="identification.number"
                           :name="'identificationNumber' + _uid">
                </div>
            </div>
        </div>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>

        <!-- TODO: Dialog -->
        <vs-prompt :title="$t('editor.common.editComponentProperties')"
                   :accept-text="$t('buttons.ok')"
                   :cancel-text="$t('buttons.cancel')"
                   :active.sync="activePrompt"
                   :is-valid="validationSuccess"
                   @cancel="cancelPrompt"
                   @close="cancelPrompt"
                   color="primary">
            <div>
                <div v-if="model.locked">
                    <h4 class="text-danger"><i class="fas fa-lock"></i> {{ $t('registers.dynamic.gridHeaders.locked') }}</h4>
                </div>

                <FieldTemplateSelector v-model="model"
                                       :isFormField="isFormField"
                                       :isAuxRegisterField="isAuxRegisterField"
                                       :isEventFieldCode="isEventFieldCode">
                </FieldTemplateSelector>

                <vs-input :label="$t('editor.common.name')" v-model="model.name" />
                <span class="text-danger" v-if="!validName">{{ $t('validation.requiredField') }}</span>

                <div class="row mt-2 mb-2 pl-3">
                    <vs-checkbox v-model="model.isTemplate">{{ $t('editor.common.saveAsTemplate') }}</vs-checkbox>
                </div>

                <vs-input :label="$t('editor.common.nameEN')" v-model="model.nameEn"></vs-input>

                <vs-input :label="$t('editor.common.label')" v-model="model.label" />
                <span class="text-danger" v-if="!validLabel">{{ $t('validation.requiredField') }}</span>
                <vs-input :label="$t('editor.common.labelEn')" v-model="model.labelEn"></vs-input>
                <span class="text-danger" v-if="!validLabelEn">{{ $t('validation.requiredField') }}</span>

                <vs-input :label="$t('editor.common.description')" v-model="model.description" />
                <vs-input :label="$t('editor.common.descriptionEn')" v-model="model.descriptionEn" />

                <size-dropdown v-model="model.size"></size-dropdown>
                <hr>
                <div class="float-left mt-2">
                    <vs-checkbox v-model="model.isRequired">{{ $t('validation.requiredField') }}</vs-checkbox>
                </div>

                <div class="clearfix"></div>
                <hr />
                <div class="float-left mt-2">
                    <vs-checkbox v-model="model.showInDescription">{{ $t('editor.common.showInDescription') }}</vs-checkbox>
                </div>

                <div class="clearfix"></div>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
    import Dropdown from '../dropdown/NomenclatureDropdown';
    import SizeDropdown from '../editor/SizeDropdown';
    import FieldTemplateSelector from '../../components/editor/FieldTemplateSelector'
    import { EditorComponentModel, PersonIdentification } from '../../models/models' // TODO:
    import { Culture, NomenclatureParentBySort } from '../../models/enums';

    export default {
        props: {
            // value: String,
            model: {
                type: EditorComponentModel
            },
            isFormField: {
                type: Boolean,
                default: false
            },
            isAuxRegisterField: {
                type: Boolean,
                required: false
            },
            isEventFieldCode: {
                type: Boolean,
                required: false
            },
        },
        components: {
            Dropdown,
            SizeDropdown,
            FieldTemplateSelector
        },
        data() {
            return {
                identification: new PersonIdentification(),
                activePrompt: false,
                originalModel: new EditorComponentModel(),
                nomenclature: NomenclatureParentBySort
            }
        },
        methods: {
            showEditPrompt() {
                this.originalModel = new EditorComponentModel(this.model);
                this.activePrompt = true;
            },
            cancelPrompt() {
                this.changeModelToOriginalModel();
            },
            changeModelToOriginalModel() {
                this.model.name = this.originalModel.name;
                this.model.nameEn = this.originalModel.nameEn;
                this.model.label = this.originalModel.label;
                this.model.labelEn = this.originalModel.labelEn;
                this.model.size = this.originalModel.size;
                this.model.isRequired = this.originalModel.isRequired;
                this.model.showInDescription = this.originalModel.showInDescription;
            },
            resetTextEditorConstraintsValues() {
                // TODO: ?
                this.model.textMinLength = this.originalModel.textMinLength;
                this.model.textMaxLength = this.originalModel.textMaxLength;
                this.model.textDefaultValue = this.originalModel.textDefaultValue;
                this.model.intMinValue = this.originalModel.intMinValue;
                this.model.intMaxValue = this.originalModel.intMaxValue;
                this.model.intDefaultValue = this.originalModel.intDefaultValue;
                this.model.decimalMinValue = this.originalModel.decimalMinValue;
                this.model.decimalMaxValue = this.originalModel.decimalMaxValue;
                this.model.decimalDefaultValue = this.originalModel.decimalDefaultValue;
                this.model.decimalPrecision = this.originalModel.decimalPrecision;
                this.model.numberFormat = this.originalModel.numberFormat;
            }
        },
        computed: {
            validationSuccess() {
                // this.model.locked - Locked for edition
                return !this.model.locked;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
        }
    }
</script>

<style scoped>
    .vs-input {
        width: 100%;
    }

    ::v-deep {
        .vs-dialog {
            min-width: 800px !important;
            height: auto;
        }
    }
</style>
